// extracted by mini-css-extract-plugin
export default {"root":"ValidationError_root__LVczR"};